export default __webpack_public_path__ + "static/media/Golden galaxy2.b427cc50.jpg";